import React, { FunctionComponent } from 'react';

import { Heading } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { RichText, RichTextProps } from './RichText';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  title: string;
  text: RichTextProps;
}

interface BlogPostSectionProps extends PageSectionProps {
  blok: Blok;
}

export const BlogPostSection: FunctionComponent<React.PropsWithChildren<BlogPostSectionProps>> = ({ blok }) => {
  const { title, text, hasBackground, hasBorder, hasPaddingTop, hasPaddingBottom } = blok;
  // convert title to id -> 'This is a Blog Post' to 'this_is_a_blog_post'
  const id = title?.toLowerCase().replace(/\W/g, '_');
  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className="pt-default pb-default"
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      {title && (
        <Heading id={id} kind="3" level="3" className="mb-6 text-primary font-medium text-3xl">
          {title}
        </Heading>
      )}
      <RichText content={text} />
    </Section>
  );
};
